(function (){
    "use strict";
    angular.module('swif.interventions')
        .controller('InterventionCostEditController', InterventionCostEditController);

    function InterventionCostEditController ($scope) {
        'ngInject';
        console.log('init InterventionCostEditController');
        var $ctrl = this;
        $ctrl.model = $scope.model;
        $ctrl.selected = {};
        if (!$ctrl.model._equipments) {
            $ctrl.model._equipments = [];
        }
        if (!$ctrl.model._consumables) {
            $ctrl.model._consumables = [];
        }
        //TODO: add real object saved on the server
        $scope.$watch('$ctrl.selected.equipment_id', function (newV) {
            if (newV) {
                delete $ctrl.selected.equipment_id;
                $ctrl.model._equipments.push({name: newV[1]});
            }
        });
        $scope.$watch('$ctrl.selected.consumable_id', function (newV) {
            if (newV) {
                delete $ctrl.selected.consumable_id;
                $ctrl.model._consumables.push({name: newV[1]});
            }
        });
    }

})();
